module.exports = require("@swa-ui/shopping/src/CollapsibleFareOption/CollapsibleFareOption.module.scss");